export const STATUSES = [
  { key: "enquiry", label: "Enquiry", cls: "bg-sky-50 text-sky-800 border-sky-200" },
  { key: "revisit_due", label: "Revisit Due", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  { key: "partial", label: "Partially Paid", cls: "bg-orange-50 text-orange-800 border-orange-200" },
  { key: "admitted", label: "Admitted", cls: "bg-plum-50 text-plum-800 border-plum-200" },
  { key: "not_interested", label: "Not Interested", cls: "bg-slate-100 text-slate-600 border-slate-300" },
];
export const CLOSED = ["admitted", "not_interested"];
export const statusOf = (r) => STATUSES.find((s) => s.key === (r.status || "enquiry"));
export const counselorOf = (r) =>
  (r.inputs.counselorName || "").trim().replace(/\s+/g, " ") || "Unassigned";

export const leaderboard = (rows) => {
  const m = {};
  rows.forEach((r) => {
    const name = counselorOf(r);
    const e = (m[name.toLowerCase()] ||= { name, receipts: 0, admitted: 0, atAdmission: 0, discount: 0 });
    e.receipts += 1;
    e.admitted += r.status === "admitted" ? 1 : 0;
    e.atAdmission += r.computed.atAdmission;
    e.discount += r.computed.totalDiscount;
  });
  return Object.values(m).sort((a, b) => b.receipts - a.receipts || b.admitted - a.admitted);
};
